export enum ROUTE_AURA {
  HOME = 'aura-home',
  URI_HOME = 'aura-thread_id',
}
